<template>
  <template v-if="userUsageLimitReached">
    <div class="absolute-center" style="max-width: 480px; width: 100%">
      <q-card bordered flat class="q-pa-xl text-center">
        <usage-meter
          :current="userUsageCurrent"
          :limit="userUsageLimit"
          :size="80"
          title="Report Usage"
          class="q-mb-md"
        />
        <div class="text-h5 text-weight-bold q-mb-md">Report Limit Reached</div>
        <div class="text-body1 text-grey-7">{{ userUsageHelpText }}</div>
      </q-card>
    </div>
    <safe-teleport to="#toolbar-portal">
      <q-toolbar
        :class="{ 'q-px-md': $q.screen.gt.xs, 'q-px-lg': $q.screen.gt.md }"
        :style="`border-bottom: 1px solid ${
          $q.dark.isActive ? 'rgba(255, 255, 255, 0.28)' : 'rgba(0, 0, 0, 0.12)'
        }`"
        class="q-px-sm row justify-center"
        style="height: 75px"
      >
        <div class="parent-card full-width row justify-end q-gutter-x-sm">
          <div style="font-size: 20px; font-weight: 500">New Development</div>
          <q-space />
          <q-btn :to="{ name: 'Dashboard' }" flat no-caps unelevated>Cancel</q-btn>
        </div>
      </q-toolbar>
    </safe-teleport>
  </template>
  <card-edit-property
    v-else
    :goto-edit-next="gotoEditNextFormatted"
    :existing-property-id="existingPropertyId"
    :goto-report-id-next="gotoReportNextFormatted"
  />
</template>

<script lang="ts">
import CardEditProperty from '@/components/CardEditProperty.vue'
import UsageMeter from '@/components/UsageMeter.vue'
import { useUserStore } from '@/stores/user'

export default {
  name: 'NewDevelopmentView',
  components: { CardEditProperty, UsageMeter },
  props: {
    gotoEditNext: {
      type: String as () => string | null,
      description:
        'If set to true, the user will be redirected to finish editing a report after creating a new property',
      default: null
    },
    existingPropertyId: {
      required: false,
      type: String as () => string | null,
      description: 'The ID of the existing property to edit',
      default: null
    },
    gotoReportIdNext: {
      type: String as () => string | null,
      description:
        'If set to a value, the user will be redirected to view that report after updating the custom property',
      default: null
    }
  },
  computed: {
    userUsageLimitReached(): boolean {
      return useUserStore().userUsageLimitReached
    },
    userUsageHelpText(): string {
      return useUserStore().userUsageHelpText
    },
    userUsageCurrent(): number {
      return useUserStore().userUsage?.numCreated ?? 0
    },
    userUsageLimit(): number {
      return useUserStore().userUsage?.limit ?? 0
    },
    gotoEditNextFormatted() {
      return this.gotoEditNext === 'true'
    },
    gotoReportNextFormatted() {
      if (this.gotoReportIdNext) {
        return parseInt(this.gotoReportIdNext)
      }
      return null
    }
  }
}
</script>
